var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAATklEQVR42mMYnIAx+NwZbJhozQwWE7BikBzxmjXzkTFxhoAlEZoxMcKANJoagA8TNoAARhiAB6QRwpS4gGAsuDOoZ3YRwoS8oEIUHj4AAHAKkSboWjCxAAAAAElFTkSuQmCC";
  export default img;